/** Stand der Datenschutzerklärung. Bei inhaltlichen Änderungen hochsetzen: Angemeldete Nutzer werden dann erneut um Zustimmung gebeten. */
export const PRIVACY_VERSION = '2026-10-16.1';
export const PRIVACY_DATE = '16. Oktober 2026';

export const OPERATOR = {
  name: 'Seven Whys Ltd.',
  street: '26 Anthipolochagou Georgiou M. Savva, Shop 1-2',
  city: '8201 Paphos',
  country: 'Zypern',
  email: 'contact@sevenwhys.com',
  vat: 'CY10418141O',
};

/** Region des Supabase-Projekts (im Supabase-Dashboard unter Project Settings → General prüfen). */
export const SUPABASE_REGION = 'Frankfurt am Main (EU)';
/** Aufbewahrung der Server-Logdateien auf dem Hetzner-Server (in der Webserver-Konfiguration einstellen). */
export const LOG_DAYS = 14;
